import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getDocDetails = createAsyncThunk(
  "Docs/getDocDetails",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/docs/folders/${data?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data?.handleSuccess) {
        data?.handleSuccess(resp.data);
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
